<template>
  <div class="select-form">
    <h2 class="label">
      {{ label }}
    </h2>
    <b-dropdown
      aria-role="list"
      :mobile-modal="false"
      v-model="selectedOption"
      @change.once="$emit('change')"
    >
      <button class="select-button" slot="trigger" @input="$emit('input', $event.target.value)">
        {{ selectedOption }}
      </button>

      <b-dropdown-item
        aria-role="listitem"
        v-for="item in data"
        :value="item.label"
        :key="item.initial"
        @click="switchInfo(item.initial)"
      >
        {{ item.label }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  data () {
    return {
      selectedOption: null
    }
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: () => { return [] }
    },
    value: {
      type: String,
      default: null
    }
  },

  watch: {
    value: {
      immediate: true,
      handler: function (newValue) {
        this.selectedOption = newValue
      }
    }
  },

  methods: {
    switchInfo (value) {
      this.$emit('switchInfo', value)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/assets/stylesheets/styleguide";
@import "~@/assets/stylesheets/forms";

  .dropdown-trigger {
    width: 100%;
  }
</style>
